/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementStartLotteryResponse } from './EventSceneManagementStartLotteryResponse';

export type EventSceneManagementStartLotteryResponseApiRespoonse = {
    data?: EventSceneManagementStartLotteryResponse;
    status?: EventSceneManagementStartLotteryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementStartLotteryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

